/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
export const colorSettings = {
  Twitter: 'source.twitter',
  Facebook: 'source.facebook',
  Instagram: 'source.instagram',
  Blogs: 'source.blogs',
  Forums: 'source.forums',
  News: 'source.news',
  Broadcast: 'source.broadcast',
  Comments: 'source.comments',
  'Professional Reviews': 'source.profReviews',
  Other: 'source.other',
  'Other Social Networks': 'source.otherSocialNetworks',
  Microblogs: 'source.microblogs',
  'Consumer Reviews': 'source.consumerReviews',
  YouTube: 'source.youtube',
  TikTok: 'source.tiktok',
  Internal: 'source.internal',
  Bluesky: 'source.bluesky',
  Reddit: 'source.reddit',
  Podcast: 'source.podcast'
}
